<section>
    <form [formGroup]="formGroup">
        <div class="filter-input row">
            <div class="col-lg-4 col-md-6 padding-left-0">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <label class="input-group-text" for="filter">
                            <i class="fa fa-search fa-2x" aria-hidden="true"></i>
                        </label>
                    </div>
                    <input type="text" #filter autocomplete="off" class="form-control filter" id="filter" formControlName="filter" placeholder="Filter by property name" aria-label="Filter by property name" aria-describedby="button-search">
                    <div class="input-group-append">
                        <label class="input-group-text" for="filter" *ngIf="filter.value" (click)="clearFilter()">
                            <i class="fa fa-times-circle fa-2x" aria-hidden="true"></i>
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 col-md-6 text-end">
                <div class="form-group">
                    <div class="form-control radio">
                        <label class="btn-radio-container padding-right-5"><input type="radio" [value]="true" formControlName="isMostRecentOnly" #isMostRecentOnly><span></span> Most Recent Only</label>
                        <label class="btn-radio-container"><input type="radio" [value]="false" formControlName="isMostRecentOnly"><span></span> All</label>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="row">
        <div class="col-md-12">

            <!-- Header -->
            <div class="row grid-header">
                <div class="col-md-4 text-start text-uppercase">Property Name</div>
                <div class="col-md-2 text-start text-uppercase">Location</div>
                <div class="col-md-2 text-start text-uppercase">Status</div>
                <div class="col-md-3 text-start text-uppercase">Date</div>
                <div class="col-md-1 text-start text-uppercase"></div>
            </div>

            <!-- Imports -->
            <ng-container *ngFor="let request of importRequests | filterImportRequests: filter.value : isMostRecentOnly.checked">
                <div class="row request" [routerLink]="['./', request.importRequestId]">
                    <div class="col-md-4">{{request.propertyName}}</div>
                    <div class="col-md-2">{{request.propertyCity}}, {{request.propertyState}}</div>
                    <div class="col-md-2">{{request.statusId | importRequestStatus}}</div>
                    <div class="col-md-3">{{request.createdOn | date: 'mediumDate'}}, {{ request.createdOn | date: 'shortTime'}}</div>
                    <div class="col-md-1 text-end">
                        <a class="btn btn-link" [routerLink]="['./', request.importRequestId]"><span class="sp-icon-edit-30 u-alignMiddle"></span></a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>
